module.exports = __webpack_public_path__ + "img/candle_counter.ed5eca65.png";